const visitInfoSx = (theme) => ({
    inputWrapper: {
        padding: theme.spacing(2),
    },
});

export default visitInfoSx;
